<p-popover
  #confirmationPanel
  [style]="style"
  [styleClass]="computedStyleClass()"
  [appendTo]="appendTo()"
  [dismissable]="dismissable"
  [autoZIndex]="autoZIndex"
  [baseZIndex]="baseZIndex"
  [focusOnShow]="focusOnShow">
  <ng-template pTemplate="content">
    <div class="flex flex-col gap-3">
      <ng-content select="#header"></ng-content>
      <ng-content select="#message"></ng-content>

      <div class="d-flex gap-2 justify-content-end">
        <button
          pButton
          class="p-button-outlined"
          [label]="rejectLabel"
          (click)="reject.emit(); confirmationPanel.hide()"></button>
        <button
          pButton
          class="p-button-primary"
          [label]="acceptLabel"
          [disabled]="isAcceptDisabled"
          (click)="accept.emit(); confirmationPanel.hide()"></button>
      </div>
    </div>
  </ng-template>
</p-popover>
